var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.856 1.14866C16.4394 0.72283 15.8227 0.56533 15.2477 0.731997L1.83935 4.60616C1.23269 4.7745 0.802687 5.25533 0.686854 5.86533C0.568521 6.487 0.981854 7.277 1.52185 7.607L5.71435 10.167C6.14435 10.4303 6.69935 10.3645 7.05519 10.0078L11.856 5.207C12.0977 4.95616 12.4977 4.95616 12.7394 5.207C12.981 5.44783 12.981 5.84033 12.7394 6.09033L7.93019 10.8912C7.57352 11.2478 7.50685 11.8012 7.76935 12.232L10.331 16.4403C10.631 16.9395 11.1477 17.2237 11.7144 17.2237C11.781 17.2237 11.856 17.2237 11.9227 17.2145C12.5727 17.132 13.0894 16.6895 13.281 16.0645L17.256 2.757C17.431 2.19033 17.2727 1.57366 16.856 1.14866Z",
    fill: "#063065"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.65063fba06b8f8497b0702d6cf98a4ee.svg";
export { ForwardRef as ReactComponent };